export const CMS_API = 'cms';
export const PORTAL_API = 'portal';
